import React, { useState } from "react";
import ARChairViewer from "./components/ARChairViewer";
import ThreeJSSelector from "./components/ThreeJSSelector";
import "./App.css";

function App() {
  const [isChairLoaded, setIsChairLoaded] = useState(false);
  const [isMarkerVisible, setIsMarkerVisible] = useState(false);
  const [activeMaterialId, setActiveMaterialId] = useState("baseColor");

  const handleMaterialSelect = (materialId) => {
    window.dispatchEvent(
      new CustomEvent("change-material", { detail: materialId })
    );
  };

  const handleChairLoaded = () => {
    setIsChairLoaded(true);
  };

  const handleMarkerVisibleChange = (visible) => {
    setIsMarkerVisible(visible);
  };

  const handleMaterialChanged = (materialId) => {
    setActiveMaterialId(materialId);
  };

  return (
    <div className="App">
      <ARChairViewer
        onChairLoaded={handleChairLoaded}
        onMarkerVisibleChange={handleMarkerVisibleChange}
        onMaterialChanged={handleMaterialChanged}
      />
      <ThreeJSSelector
        onSelect={handleMaterialSelect}
        activeMaterialId={activeMaterialId}
        visible={isChairLoaded && isMarkerVisible}
      />
    </div>
  );
}

export default App;
